"use client";
import React, {useState, useEffect} from "react";
import PayList from "./payList";
import $http from "@/app/_api";
import {GetUserLatestOrdersResponse} from "@/app/_api/types/store";
import styles from "./page.module.css";
import {useAppSelector} from "@/app/storeHooks";
import {selectUserInfo} from "@/app/userSlice";
import FontIcon from "../../_components/FontIcon/fontIcon";
import Load from "@/app/_components/Load/Load";

export default function PayRecordsUI() {
    const [dataList, setDataList] = useState<GetUserLatestOrdersResponse>([] as GetUserLatestOrdersResponse);
    const [isDataOk, setIsDataOk] = useState<boolean>(false);
    const userInfo = useAppSelector(selectUserInfo);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setIsDataOk(false);
        const data = await $http.Store.getUserLatestOrder({userId: userInfo.userId});
        setIsDataOk(true);
        data && setDataList(data);
        return data;
    }

    let isUpdating = false;
    const onClickUpdate = async () => {
        if (isUpdating) return;
        isUpdating = true;
        await getData();
        isUpdating = false;
    }

    return (
        <div className={styles.page}>
            {/*<div className={styles.goBack} onClick={() => router.back()}>*/}
            {/*    <FontIcon item="s-back"/>*/}
            {/*</div>*/}

            {/*<div className={styles.header}>RECHARGE HISTORY</div>*/}


            {
                isDataOk ? <>
                    {dataList.length === 0 && <div className={styles.empty}>No data...</div>}

                    {dataList.length > 0 && <PayList dataSource={dataList}/>}

                    <div className={styles.tips}>Only show the last 10 records</div>
                    <div className={`btn ${styles.btn_refresh} center`} onClick={onClickUpdate}>
                        <FontIcon
                            icon={'s-refresh'}
                            style={{
                                color: '#fff',
                                verticalAlign: '-0.1rem'
                            }}
                        />
                    </div>
                </> : <Load/>
            }


        </div>
    )
}